export enum generalSettingsTypes {
    FETCH_GENERAL_SETTINGS_REQUEST = 'FETCH_GENERAL_SETTINGS_REQUEST',
    FETCH_BRAINTREE_TOKEN_REQUEST = 'FETCH_BRAINTREE_TOKEN_REQUEST',
    EDIT_GENERAL_SETTINGS_REQUEST = 'EDIT_GENERAL_SETTINGS_REQUEST',
    SET_GENERAL_SETTINGS = 'SET_GENERAL_SETTINGS',
}
